import { query } from "./dataClient.js";

// A finding can name an older request. Resolve that request's session before
// opening the whole retained conversation, never its time-bounded prefix.
export async function loadFindingSession(id, runQuery = query) {
    let trace = await runQuery("getTrace", { id });
    if (trace?.sessionId && (trace.requestId || Number.isFinite(trace.record?.untilMs))) {
        trace = await runQuery("getTrace", { id: trace.sessionId });
    }
    if (!trace) throw new Error("This session is no longer available.");
    if (trace.requestId || Number.isFinite(trace.record?.untilMs)) throw new Error("The complete session could not be resolved.");
    return trace;
}
